// @ts-strict-ignore
import type { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance'
import type { ActionContext } from 'vuex'
import type { ActionClass, ConfigState } from '../../../models'
import type { InstancesProvider } from '../../../providers/interfaces'
import { CONTAINER } from '../../../config/inversify.config'
import { TYPES } from '../../../config/inversify.types'
import { CONFIG_CONSTS } from '../../../store/config/config.consts'

export class LoadInstancesAction implements ActionClass {
  static async execute(
    this: void,
    { commit }: ActionContext<ConfigState, unknown>,
  ): Promise<Array<Instance>> {
    try {
      const instances = await CONTAINER.get<InstancesProvider>(TYPES.InstancesProvider)()
      commit(CONFIG_CONSTS.mutations.setInstances, instances)
      return instances
    } catch (error) {
      return []
    }
  }
}
